import colorLibraryActivation from '../../shared/colorLibraryActivation.cjs';

const STORAGE_KEY = 'color_library_signup_context';
const MAX_AGE = 60 * 60 * 1000;

export const safeLibraryReturn = (path) =>
    colorLibraryActivation.isLibraryToolReturn(path) ? path : '/app/color-library/';

export const rememberLibrarySignupContext = (source, intent = {}) => {
    if (typeof window === 'undefined' || !colorLibraryActivation.isLibrarySource(source)) return;
    try {
        window.sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
                ...colorLibraryActivation.signupState(source),
                createdAt: Date.now(),
                returnTo: safeLibraryReturn(intent.returnTo),
                pendingColor: /^#[0-9a-f]{6}$/i.test(intent.color) ? intent.color : undefined,
            }),
        );
    } catch {
        /* Storage is optional; authentication still works. */
    }
};

export const readLibrarySignupContext = () => {
    if (typeof window === 'undefined') return undefined;
    try {
        const context = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
        if (
            !context ||
            !colorLibraryActivation.isLibrarySource(context.signupSource) ||
            !Number.isFinite(context.createdAt) ||
            context.createdAt > Date.now() ||
            Date.now() - context.createdAt > MAX_AGE
        ) {
            window.sessionStorage.removeItem(STORAGE_KEY);
            return undefined;
        }
        return {
            ...context,
            returnTo: safeLibraryReturn(context.returnTo),
            pendingColor: /^#[0-9a-f]{6}$/i.test(context.pendingColor)
                ? context.pendingColor
                : undefined,
        };
    } catch {
        return undefined;
    }
};

export const clearLibrarySignupContext = () => {
    try {
        if (typeof window !== 'undefined') window.sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        /* Storage may be disabled. */
    }
};
